<template lang="pug">
el-drawer(:title="flowVersion" :visible.sync="versionDialog" direction="rtl" size="800px" :before-close="versionClose")
  el-table(
    v-loading="loading"
    :data="versionList"
    element-loading-text="数据加载中"
    border
    highlight-current-row)
    el-table-column(label="版本号" prop="version" align="center" v-slot="{row}")
      el-link(type="primary" @click="versionSee(row)")
        span(class="tabLinkSpan" :title='row.version') {{ row.version }}
    el-table-column(prop="operDate" show-overflow-tooltip label="修改时间" align="center")
    el-table-column(prop="operUserName" show-overflow-tooltip label="修改人" align="center")
    el-table-column(prop="isRelease" label="是否发布" align="center" v-slot="{row}")
      span(v-if="row.isRelease == 0" style="color:#ec3226") 未发布
      span(v-if="row.isRelease == 1") 已发布
    el-table-column(label="版本状态" align="center" v-slot="{row}")
      span(v-if="row.isCurrentVersion===1") 已为当前版本
    el-table-column(label="操作" align="center" min-width="180px" v-slot="{row}")
      el-button(type="text" @click="versionSee(row)") 查看
      el-button(type="text" v-if="row.isRelease == 0" @click="showReleaseDialog(row)") 发布
      el-button(type="text" v-if="row.isCurrentVersion===0 && row.isRelease === 1" @click="setNowVersion(row)") 设置为当前版本
  el-dialog(title="发布" append-to-body :visible.sync="releaseVisible" width="20%" :before-close="closeRelease")
    el-radio(v-model="releaseStatus" :label="0") 仅发布
    el-radio(v-model="releaseStatus" :label="1") 发布并设为当前版本
    template(#footer)
      el-button(size="small" @click="closeRelease") 取消
      el-button(size="small" type="primary" @click="startRelease") 确定
</template>

<script>
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
export default {
  data () {
    return {
      versionDialog: false,
      loading: false,
      flowName: '',
      versionList: [],
      releaseVisible: false,
      releaseStatus: 0,
      flowDefinitionId: "",
      flowDefinitionVersionId: "",
      flowKey: ""
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    flowVersion() {
      return this.flowName + "-流程版本";
    }
  },
  methods: {
    openVersion(row) {
      this.flowName = row.flowName;
      this.flowDefinitionId = row.flowDefinitionId;
      this.flowKey = row.flowKey;
      this.versionDialog = true;
      this.getVersionData();
    },
    // 获取版本列表数据
    async getVersionData() {
      this.loading = true;
      const res = await flowService.getVersionList(this.flowDefinitionId);
      this.versionList = res.data?.reverse() || [];
      this.loading = false;
    },
    setNowVersion(row) {
      this.$confirm(`您确定设置为当前版本吗?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "el-message-box"
      }).then(async () => {
        const { flowDefinitionId, flowDefinitionVersionId } = row;
        const params = {
          flowDefinitionId,
          flowDefinitionVersionId,
          enterpriseId: this.enterpriseId,
          releaseStatus: 0// 仅发布:0 ;发布并设为当前版本:1
        };
        await flowService.setNowVersion(params);
        this.$emit("updateSet");
        this.$success("版本设置成功");
        this.getVersionData();
      }).catch(() => {
        // this.$message.info("已取消删除");
      });
    },
    versionSee(row) {
      this.versionDialog = false;
      this.$emit("seeVersion", row, this.flowKey);
    },
    versionClose() {
      this.versionDialog = false;
    },
    showReleaseDialog(row) {
      this.flowDefinitionId = row.flowDefinitionId;
      this.flowDefinitionVersionId = row.flowDefinitionVersionId;
      this.releaseVisible = true;
    },
    async startRelease() {
      const params = {
        flowDefinitionId: this.flowDefinitionId,
        flowDefinitionVersionId: this.flowDefinitionVersionId,
        enterpriseId: this.enterpriseId,
        releaseStatus: this.releaseStatus
      };
      try {
        await flowService.release(params);
        this.releaseVisible = false;
        await this.getVersionData();
        this.$success("版本发布成功");
        this.$emit("updateSet");
      } catch (error) {
        console.log(error);
      }
    },
    closeRelease() {
      this.releaseVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
<style lang="scss">
.el-drawer__header{
  margin-bottom: 10px;
}
.el-drawer__header>span{
  font-weight: 700;
  font-size: 15px;
}
</style>
